exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table td[data-v-5301cdfe]{border:none}.table-hints[data-v-5301cdfe],table td[data-v-5301cdfe]{font-size:14px}", ""]);

// exports
